module.exports = "/fonts/Simple-Line-Icons.woff?78f07e2c2a535c26ef21d95e41bd7175";